<template>
  <div class="mb-2">
    <AppFilter :filters="filterConfig" :filter-submitting="filterSubmitting" @filter="handleFilter">
    </AppFilter>
  </div>
</template>
<script>
import { helper } from '@core/mixins/helper.js';
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    AppFilter
  },

  mixins: [helper],
  props: {
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      values: {
        customer_id: ''
      },
      submitting: false,
      files: null,
      formData: null,
      progressShow: false,
      totalProgressValue: 0,
      spinning: false
    };
  },

  computed: {
    ...mapGetters({
      pickupConsignmentStatus: 'app/pickupConsignmentStatus'
    }),
    statusOptions() {
      return (this.pickupConsignmentStatus || []).map(item => ({
        value: item.value,
        label: item.text
      }));
    },
    filterConfig() {
      return [
        {
          id: 'tracking_number',
          label: this.$t('Barcode/Reference Number'),
          type: 'text',
          placeholder: this.$t('Barcode/Reference Number')
        },
        {
          id: 'status',
          label: this.$t('Status'),
          type: 'select',
          options: this.statusOptions,
          placeholder: this.$t('Make a Choice')
        }
      ];
    }
  },
  methods: {
    handleFilter(filters) {
      this.$emit('filter', filters);
      this.values = filters;
    }
  }
};
</script>
